import { connect } from "react-redux";

import { withResolvePaths } from "../../withResolvePaths";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withViewModelSelect } from "../../withViewModelSelect";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";

import { SingleUnit } from "./SingleUnit";

const mapStateToProps = (state: FullFormState) => ({
    emptyUnits: state.emptyUnits,
});

export const SingleUnitContainer = withResolvePaths(
    withFocusManagement(withViewModelSelect(connect(mapStateToProps)(SingleUnit)))
);
